var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 220 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M76.2 55.144v1.936c0 4.356-3.564 7.92-7.92 7.92H52l1.76-5.808h14.388c1.232 0 2.2-1.012 2.2-2.2v-1.716c0-1.232-.968-2.2-2.2-2.2H59.92c-4.356 0-7.92-3.564-7.92-7.92V43.22c0-4.356 3.564-7.92 7.92-7.92H74l-1.76 5.852H60.008c-1.188 0-2.2.968-2.2 2.2v1.672c0 1.232 1.012 2.2 2.2 2.2h8.272c4.356 0 7.92 3.564 7.92 7.92zM102.644 35.3L92.128 51.052V65h-5.852V49.248l1.364-2.024h-3.916L75.76 35.3h6.996l6.424 9.592 6.468-9.592h6.996zm23.584 0h5.808V65h-5.808V46.52l-5.544 9.108h-4.488l-5.544-9.108V65h-5.808V35.3h5.808l7.788 12.804 7.788-12.804zm34.188 12.848v.132-.132zm0-5.06v.132-.132zm0 5.192c-.088 4.312-3.608 7.788-7.92 7.788h-8.184l1.76-5.852h6.292c1.232 0 2.2-.968 2.2-2.2v-4.664c0-1.232-.968-2.2-2.2-2.2h-10.34V65h-5.808V35.3h16.28c4.312 0 7.832 3.476 7.92 7.788v5.192zm25.96-12.98V65h-5.852V53.076h-10.34V65h-5.808V35.3h5.808v14.872l2.948-2.948h7.392V35.3h5.852zm19.58 0c4.356 0 7.92 3.564 7.92 7.92v13.86c0 4.356-3.564 7.92-7.92 7.92h-7.48c-4.356 0-7.92-3.564-7.92-7.92V43.22c0-4.356 3.564-7.92 7.92-7.92h7.48zm2.068 21.692v-13.64c0-1.232-.968-2.2-2.2-2.2h-7.26c-1.188 0-2.2.968-2.2 2.2v13.64c0 1.188 1.012 2.2 2.2 2.2h7.26c1.232 0 2.2-1.012 2.2-2.2zM240.936 65h-5.852l-11.22-18.48V65h-5.808V35.3h5.808l11.22 18.48V35.3h5.852V65zM269.8 35.3l-10.516 15.752V65h-5.852V49.248l1.364-2.024h-3.916L242.916 35.3h6.996l6.424 9.592 6.468-9.592h6.996z",
    id: "a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-51 -34)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#8800FF",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#8800FF",
    xlinkHref: "#a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.782a0546.svg";
export { ForwardRef as ReactComponent };